"use strict";
/**
 * index
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Key = void 0;
// import {fromJwkTo, toJwkFrom} from './converter.js';
// import {getJwkThumbprint} from './thumbprint.js';
// import {isAsn1Encrypted} from './util.js';
var key = __importStar(require("./key"));
// export default {fromJwkTo, toJwkFrom, getJwkThumbprint, isAsn1Encrypted, Key};
// export {fromJwkTo, toJwkFrom, getJwkThumbprint, isAsn1Encrypted, Key};
exports.Key = key.Key;
exports.default = { Key: exports.Key };
//# sourceMappingURL=index.js.map